'use client';

import type { ApolloQueryResult } from '@apollo/client';
import { createContext, type FC, type PropsWithChildren, useRef } from 'react';
import type { TariffsQuery } from '../../types/generated';

export const Context = createContext<Promise<ApolloQueryResult<TariffsQuery>> | null>(null);

export const DynamicTariffsContext: FC<
  PropsWithChildren & {
    tariffs: Promise<ApolloQueryResult<TariffsQuery>> | null;
  }
> = ({ children, tariffs }) => {
  const cachedTariffs = useRef(tariffs);

  if (tariffs !== null) {
    cachedTariffs.current = tariffs;
  }

  return <Context.Provider value={cachedTariffs.current}>{children}</Context.Provider>;
};
